"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".suggestionsContainer_54c57b9b{overflow-y:auto;overflow-x:hidden;max-height:300px}.suggestionsContainer_54c57b9b .ms-Suggestion-item:hover{background-color:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";cursor:pointer}.suggestionsContainer_54c57b9b .is-suggested{background-color:" }, { "theme": "themeLighter", "defaultValue": "#deecf9" }, { "rawString": "}.suggestionsContainer_54c57b9b .is-suggested:hover{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";cursor:pointer}\n" }]);
exports.suggestionsContainer = "suggestionsContainer_54c57b9b";
//# sourceMappingURL=SuggestionsCore.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/FloatingPicker/Suggestions/SuggestionsCore.scss.js
// module id = 1033
// module chunks = 0